import React, { Fragment } from 'react'
import {
    LinkOrDiv,
    SpanOrDiv,
    getDate,
} from '../../events/helpers'
import { wrapperHighlightPin } from '../../../../components/shared/toggle-highlight-pin'
import classnames from 'classnames'
import Configurator from '../../../../configurator'
import {
    EVENT_NAVIGATION,
    TYPE_EVENT_DETAIL,
    sendWebViewEvent,
} from '../../../../events-webview'
import SnIcon from '../sn-icon'
import { i18n } from '../../../../validator'
import { ImageResized } from '../../../../components/shared/webp-image-resized'
import { E_CANCELLED } from '../../../../consts'
import Subscribe from '../../events/detail/parts/subscribe'

const DangerIcon = '/images/danger-white.png'
const AttendeesIcon = '/images/attendees.svg'
const OrganizerIcon = '/images/organizator-darker.svg'
const DefaultHeaderImage = '/images/default-detail-logo_2.jpg'

@i18n()
class Box extends Configurator {

    state = {
        showError: false,
    }

    getLocationName = () => {
        const event = this.props.event
        let locationName = ''

        if (event.locations && event.locations.data) {
            const mainLocation = event.locations.data[0]
            if (!mainLocation) {
                return ''
            }

            locationName = mainLocation.formatted_address || mainLocation.street
        }

        return locationName
    }

    /**
     * Redirect after a click on an event and send JS event in WebView
     *
     * @param {Object} event
     */
    redirectToEvent = event => {
        const { t } = this.props
        if (!event.user_can_show) {
            this.props.sendError(t('eventIsPrivateErrorMessage'))
        } else {
            const webViewData = {
                close: true,
                data: {
                    ...TYPE_EVENT_DETAIL,
                    slug: event.slug,
                },
            }
            sendWebViewEvent(EVENT_NAVIGATION, webViewData)
            this.scrollTop()
        }
    }

    /**
     * Render date time content
     *
     * @param {Object} event
     * @returns {*}
     */
    renderDate = event => {
        if (event.approx_date) {
            return null
        }

        const dateFrom = getDate(event, 'start_date', 'D')

        return (
            <Fragment>
                {dateFrom}
            </Fragment>
        )
    }

    /**
     * Render month
     *
     * @param {Object} event
     * @return {*}
     */
    renderMonth = event => {
        if (event.approx_date) {
            return null
        }

        const dateMonth = getDate(event, 'start_date', 'MMM.')

        return (
            <Fragment>
                {dateMonth}
            </Fragment>
        )
    }

    renderHeader = (event, additionalInfo, mainClassName) => {
        const {
            t,
            smallBox,
        } = this.props

        if (smallBox) {
            return (
                <div className="event-card__header my-3">
                    <ImageResized
                        src={additionalInfo?.home?.image}
                        alt=""
                        size="logo-md"
                    />
                    {additionalInfo.opponent &&
                        <>
                            <span className="mx-2">{t('versus')}</span>
                            <ImageResized
                                src={additionalInfo?.opponent?.image}
                                alt={t('opponentLogoImageAlternative')}
                                size="logo-md"
                            />
                        </>
                    }
                </div>
            )
        }

        return (
            <div className={classnames({
                [`${mainClassName}__event-item__header`]: true,
            })}>
                <h2 className={classnames({
                    [`${mainClassName}__event-item__header__heading`]: true,
                    [`${mainClassName}__event-item__header__heading--single`]: !additionalInfo.opponent,
                })}>
                    <div className={`${mainClassName}__event-item__logo`}>
                        <ImageResized
                            src={additionalInfo?.home?.image}
                            alt=""
                            size="logo-md"
                        />
                    </div>
                    <span>
                        {additionalInfo.home.name}
                    </span>
                </h2>
                {additionalInfo.opponent &&
                    <Fragment>
                        <span className={`${mainClassName}__event-item__vs`}>{t('versus')}</span>
                        <h2 className={`${mainClassName}__event-item__header__heading`}>
                            <div className={`${mainClassName}__event-item__logo`}>
                                <ImageResized
                                    src={additionalInfo?.opponent?.image}
                                    alt={t('opponentLogoImageAlternative')}
                                    size="logo-md"
                                />
                            </div>
                            <span>{additionalInfo.opponent.name}</span>
                        </h2>
                    </Fragment>
                }
            </div>
        )
    }

    renderDescription = (event, additionalInfo, mainClassName) => {
        const {
            t,
            smallBox,
        } = this.props

        if (smallBox) {
            return (
                <div className="event-card__description">
                    <div className="event-card__description-content">
                        <span className="event-card__event-name">
                            <span>
                                {additionalInfo?.home?.name}
                            </span>
                            {additionalInfo?.opponent &&
                                <span
                                    className={`${mainClassName}__event-item__desc__event-name__opponent`}
                                >
                                    {` ${t('versus')} ${additionalInfo?.opponent?.name}`}
                                </span>
                            }
                        </span>
                        <span className="event-card__date">
                            {additionalInfo?.formattedDate}
                        </span>
                        <span className="event-card__event-type py-2">
                            {t(`eventTypes.${parseInt(event.type_id, 10) - 1}`)}
                        </span>
                        <span className="event-card__organised-by">
                            {additionalInfo?.formattedOrganiserGroupPath || additionalInfo?.organiser}
                        </span>
                    </div>
                </div>
            )
        }

        return (
            <div className={`${mainClassName}__event-item__desc`}>
                <div className={`${mainClassName}__event-item__desc__event-name`}>
                    <span>
                        {additionalInfo.home.name}
                    </span>
                    {additionalInfo.opponent &&
                        <span
                            className={`${mainClassName}__event-item__desc__event-name__opponent`}
                        >
                            {` ${t('versus')} ${additionalInfo.opponent.name}`}
                        </span>
                    }
                </div>
                <div className="date-box__date">
                    {!event.approx_date &&
                        <Fragment>
                            <span className="date-box__month">
                                {this.renderMonth(event)}
                            </span>
                            <span className="date-box__day">
                                {this.renderDate(event)}
                            </span>
                        </Fragment>
                    }
                    {event.approx_date &&
                        <i className="fas fa-calendar date-box__calendar" />
                    }
                </div>
                <div className={`${mainClassName}__event-item__desc__content`}>
                    <h3 className={`${mainClassName}__event-item__time text-lowercase`}>
                        {additionalInfo.formattedDate}
                    </h3>
                    {(this.props.showAddress && this.getLocationName() !== '') &&
                        <SpanOrDiv
                            printSpan={false}
                            separatorSpan={!event.approx_date ? ' - ' : ''}
                            className={`${mainClassName}__event-item__adress`}
                        >
                            {this.getLocationName()}
                        </SpanOrDiv>
                    }
                    <div className={`${mainClassName}__event-item__competition d-flex align-items-center`}>
                        <span
                            className={`${mainClassName}__event-item__competition-name`}
                        >
                            {t(`eventTypes.${parseInt(event.type_id, 10) - 1}`)}
                        </span>
                    </div>
                    <div className={`${mainClassName}__event-item__categories text-truncate`}>
                        <span
                            className={`${mainClassName}__event-item__category`}
                        >
                            {additionalInfo.formattedOrganiserGroupPath ? additionalInfo.formattedOrganiserGroupPath : additionalInfo.organiser}
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Render status bar for event boxes not on events list
     *
     * @param {Object} additionalInfo
     * @return {*}
     */
    renderBoxStatus = additionalInfo => {
        const { t } = this.props

        return (
            <Fragment>
                {!!(additionalInfo?.userStatus?.isOwner) &&
                    <div className="Entity-box__status-element">
                        <img src={OrganizerIcon} alt={t('organizerIconImageAlternative')} className="Entity-box__status-element-icon" />
                    </div>
                }
                {(!!(additionalInfo?.userStatus?.isInvited)) &&
                    <div className="Entity-box__status-element">
                        <SnIcon className="sn-invitation sn-xs text-color-accent" />
                    </div>
                }
                {!!(additionalInfo?.userStatus?.isAttendance) &&
                    <div className="Entity-box__status-element">
                        <SnIcon className="sn-confirm sn-xs text-color-brand" />
                    </div>
                }
                {!!(additionalInfo?.userStatus?.isCheering) &&
                    <div className="Entity-box__status-element">
                        <SnIcon className="sn-cheer-circle-fill sn-xs text-color-brand" />
                    </div>
                }
                {!!(additionalInfo?.formattedAttendance) &&
                    <div className="Entity-box__status-element">
                        <img src={AttendeesIcon} alt={t('participantsPluralIconImageAlternative')} className="Entity-box__status-element-icon" />
                        <span className="Entity-box__status-element-text">{additionalInfo.formattedAttendance}</span>
                    </div>
                }
            </Fragment>
        )
    }

    /**
     * Render status bar for event boxes on event list
     *
     * @param {Object} additionalInfo
     * @param {Object} event
     * @param {Object} mainClassName
     * @return {*}
     */
    renderBoxStatusEventsList = (additionalInfo, event, mainClassName) => {
        const { t } = this.props

        return (
            <Fragment>
                {!!(additionalInfo?.formattedAttendance) &&
                    <div className={`${mainClassName}__event-item__footer__icon`}>
                        <img src="/images/tick.png" alt={t('participantIconImageAlternative')} className="u-icon"/>
                    </div>
                }
                {event.cheers_count !== 0 &&
                    <span
                        className={`${mainClassName}__event-item__footer__text`}
                    >
                        {t('isCheering', { count: event.cheers_count })}
                    </span>
                }
                {(event.cheers_count !== 0 && !!(additionalInfo?.formattedAttendance)) &&
                    <span
                        className={`${mainClassName}__event-item__footer__text ${mainClassName}__event-item__footer__text--both`}>
                        &nbsp;{t('and')}&nbsp;
                    </span>
                }
                {!!(additionalInfo?.formattedAttendance) &&
                    <span
                        className={`${mainClassName}__event-item__footer__text overflow-hidden ellipsis-clamp-1`}
                    >
                        {t('countParticipants', { count: additionalInfo.formattedAttendance })}
                    </span>
                }
            </Fragment>
        )
    }

    /**
     * Render footer bar for event boxes
     *
     * @param {Object} event
     * @param {Object} additionalInfo
     * @param {Object} mainClassName
     * @param {boolean} showFooterBox
     * @return {*}
     */
    renderEventUserStatus = (event, additionalInfo, mainClassName, showFooterBox) => (
        <Fragment>
            {showFooterBox && (
                this.renderBoxStatusEventsList(additionalInfo, event, mainClassName)
            )}

            {!showFooterBox &&
                <div className="Entity-box__status">
                    {this.renderBoxStatus(additionalInfo)}
                </div>
            }
        </Fragment>
    )

    /**
     * Render new event-card component
     *
     * @param {Object} props
     * @return {JSX.Element}
     */
    renderSmallBox = props => {
        const {
            event,
            t,
            mainClassName,
            showFooterBox,
        } = props

        const additionalInfo = event.additionalInfo ? event.additionalInfo.data : null

        const hasStatus =
            !!(additionalInfo?.userStatus)
            && (additionalInfo.userStatus.isOwner
                || additionalInfo.userStatus.isInvited
                || additionalInfo.userStatus.isAttendance
                || additionalInfo.userStatus.isCheering
            )
        const hasCheers = event.cheers_count !== 0
        const hasFormattedAttendance = !!(additionalInfo?.formattedAttendance)
        const routes = this.config.REACT_APP_TRANSLATION_ROUTES

        return (
            <LinkOrDiv
                className={`${mainClassName}`}
                onClick={() => this.redirectToEvent(event)}
                href={event?.user_can_show
                    ? `/${routes?.events}/${event?.slug}`
                    : null
                }
                reactLink={true}>
                {!event?.user_can_show &&
                    <div className={`${mainClassName}__event-box-private`}>
                        {t('privateEventText')}
                    </div>
                }

                <span className={`${mainClassName}__sport`}>
                    {event?.state_id === E_CANCELLED
                        ? ''
                        : (event?.sports?.data?.length > 1
                            ? t('moreSports')
                            : event?.sports?.data?.[0]?.name
                        )}
                </span>

                {event?.state_id === E_CANCELLED &&
                    <div className={`${mainClassName}__event-box-content-status-error`}>
                        <img src={DangerIcon} alt={t('dangerIconImageAlternative')} /> {t('eventNotHappen')}
                    </div>
                }

                {this.renderHeader(event, additionalInfo, mainClassName)}

                <div className={`${mainClassName}__event-item__image`}>
                    {event?.isOnline &&
                        <div className={`${mainClassName}__event-item__image-overlay`}>ONLINE</div>
                    }
                </div>

                {this.renderDescription(event, additionalInfo, mainClassName)}

                <div className={`${mainClassName}__footer`}>
                    {(hasStatus || hasCheers || hasFormattedAttendance) &&
                        this.renderEventUserStatus(event, additionalInfo, mainClassName, showFooterBox)
                    }
                    {!hasCheers && !hasFormattedAttendance &&
                        <span className={`${mainClassName}__event-item__footer__text ${mainClassName}__event-item__footer__text--first w-100 ml-0`}>
                            {t('fanFooterText')}
                        </span>
                    }
                </div>
            </LinkOrDiv>
        )
    }

    render() {
        const {
            event,
            mainClassName,
            showFooterBox,
            smallBox,
            t,
        } = this.props
        const additionalInfo = event.additionalInfo ? event.additionalInfo.data : null

        if (!additionalInfo) {
            return null
        }

        const hasStatus =
            !!(additionalInfo?.userStatus)
            && (additionalInfo.userStatus.isOwner
                || additionalInfo.userStatus.isInvited
                || additionalInfo.userStatus.isAttendance
                || additionalInfo.userStatus.isCheering
            )
        const hasCheers = event.cheers_count !== 0
        const hasFormattedAttendance = !!(additionalInfo?.formattedAttendance)
        const routes = this.config.REACT_APP_TRANSLATION_ROUTES

        if (smallBox) {
            return this.renderSmallBox(this.props)
        }

        return (
            <div className={`${mainClassName}__event-item`}>
                <LinkOrDiv
                    className="text-decoration-none text-color-gray-dark-2"
                    onClick={() => this.redirectToEvent(event)}
                    href={event.user_can_show ? `/${routes.events}/${event.slug}` : null}
                    reactLink={true}
                >
                    {!event.user_can_show &&
                        <div className={`${mainClassName}__event-box-private`}>
                            {t('privateEventText')}
                        </div>
                    }

                    <span className={`${mainClassName}__event-item__main-category`}>
                        {event.state_id === E_CANCELLED ? '' : (event?.sports?.data?.length > 1 ? t('moreSports') : event?.sports?.data?.[0]?.name)}
                    </span>

                    {event.state_id === E_CANCELLED &&
                        <div className={`${mainClassName}__event-box-content-status-error`}>
                            <img src={DangerIcon} alt={t('dangerIconImageAlternative')} /> {t('eventNotHappen')}
                        </div>
                    }

                    {this.renderHeader(event, additionalInfo, mainClassName)}

                    <div className={`${mainClassName}__event-item__image`}>
                        <ImageResized
                            src={event?.headerImage?.data?.path}
                            size="cover-sm"
                            defaultSrc={DefaultHeaderImage}
                            title={'Banner ' + event?.name}
                            alt={event?.name}
                        />

                        {event?.isOnline &&
                            <div className={`${mainClassName}__event-item__image-overlay`}>ONLINE</div>
                        }
                    </div>

                    {this.renderDescription(event, additionalInfo, mainClassName)}
                </LinkOrDiv>

                <div className={`${mainClassName}__event-item__footer h-auto flex-row`}>
                    <Subscribe
                        event={event}
                        entity={event}
                        fromList
                    />
                    <div className="d-flex align-items-center overflow-hidden text-nowrap">
                        {(hasStatus || hasCheers || hasFormattedAttendance) &&
                            this.renderEventUserStatus(event, additionalInfo, mainClassName, showFooterBox)
                        }
                        {!hasCheers && !hasFormattedAttendance &&
                            <span className={`${mainClassName}__event-item__footer__text ${mainClassName}__event-item__footer__text--first`}>
                                {t('fanFooterText')}
                            </span>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default wrapperHighlightPin(Box, 'event')
